import { render, staticRenderFns } from "./singleTag.vue?vue&type=template&id=a6ca32a6&"
import script from "./singleTag.vue?vue&type=script&lang=js&"
export * from "./singleTag.vue?vue&type=script&lang=js&"
import style0 from "./singleTag.vue?vue&type=style&index=0&id=a6ca32a6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.0_68125b3067bc9264b7f5e63a32c23d52/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports